import { render, staticRenderFns } from "./process_route_list.vue?vue&type=template&id=bc0298d0&scoped=true"
import script from "./process_route_list.vue?vue&type=script&lang=js"
export * from "./process_route_list.vue?vue&type=script&lang=js"
import style0 from "./process_route_list.vue?vue&type=style&index=0&id=bc0298d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0298d0",
  null
  
)

export default component.exports